import React from 'react'

import PropTypes from 'prop-types'

import { defaultProps, propTypes } from '~/src/Annotations/Formatters/utils'

import { formatters } from './utils'

export { default as IconFormatter } from './IconFormatter'

const displayName = 'Annotation/Notification'

export const NotificationFormatter = ({
  annotation,
  color = defaultProps.color,
  tooltip = false,
  ...props
}) => {
  if (!annotation) return null

  const { dataTypeKey, key } = annotation

  let { [key]: ContentFormatter } = formatters
  if (!ContentFormatter) {
    ContentFormatter = dataTypeKey
      ? formatters.defaultWithDataType
      : formatters.default
  }

  return (
    <ContentFormatter
      {...props}
      annotation={annotation}
      color={color}
      tooltip={tooltip}
    />
  )
}
NotificationFormatter.propTypes = {
  annotation: PropTypes.shape({
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
      zone: PropTypes.string,
      value: PropTypes.string,
      threshold: PropTypes.string,
    })]),
    dataTypeKey: PropTypes.string,
    key: PropTypes.string,
    subject: PropTypes.string,
    message: PropTypes.string,
  }).isRequired,
  color: propTypes.color,
  tooltip: PropTypes.bool,
}
NotificationFormatter.displayName = displayName

const Memoized = React.memo(NotificationFormatter)
export default Memoized
